<template>
    <v-container>
        <v-row class="d-flex justify-center white--text">
            <v-img
                :src="require('../../assets/icn_voto_mesas_white.svg')"
                max-height="3rem"
                max-width="3rem"
            ></v-img>
            <h1>Mesas de votación<br />{{ user.name }}</h1>
        </v-row>
        <v-row
            class="d-flex justify-center mt-4 table-admins"
            v-if="permissionAdmin()"
        >
            <v-data-table
                class="datatable-admins"
                :headers="headersAdmins"
                :items="mesas"
                :search="searchAdmins"
            >
                <template v-slot:top>
                    <v-select
                        :items="elecciones"
                        :item-text="textItemElection"
                        class="mx-4"
                        item-value="id"
                        label="Selecciona elección"
                        v-model="electionIdSelected"
                        @change="onChangeElection"
                        :loading="isLoading"
                    >
                    </v-select>
                    <v-text-field
                        v-model="searchAdmins"
                        label="Buscar"
                        class="mx-4"
                    ></v-text-field>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    {{ getStatusMesa(item) }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-list-item>
                        <v-list-item-action>
                            <v-row no-gutters>
                                <v-col cols="12" sm="6" md="6">
                                    <v-btn
                                        :disabled="isLoading"
                                        icon
                                        @click="openAlta(item)"
                                        color="#01579b"
                                    >
                                        <i class="fa fa-box-open"></i>
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-btn
                                        v-if="item.apertura_file_url != null"
                                        :disabled="isLoading"
                                        icon
                                        @click="
                                            openAltaFirmada(
                                                item.apertura_file_url
                                            )
                                        "
                                        :color="'#01579b'"
                                    >
                                        <i class="fa fa-file-pdf"></i>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" sm="6" md="6">
                                    <v-btn
                                        :disabled="
                                            isLoading || !electionFinished
                                        "
                                        icon
                                        @click="openCierre(item)"
                                        :color="
                                            electionFinished ? '#01579b' : ''
                                        "
                                    >
                                        <i class="fa fa-box"></i>
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-btn
                                        v-if="item.cierre_file_url != null"
                                        :disabled="
                                            isLoading || !electionFinished
                                        "
                                        icon
                                        @click="
                                            openCierreFirmada(
                                                item.cierre_file_url
                                            )
                                        "
                                        :color="
                                            electionFinished ? '#01579b' : ''
                                        "
                                    >
                                        <i class="fa fa-file-pdf"></i>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-list-item-action>
                    </v-list-item>
                </template>
            </v-data-table>
        </v-row>
        <v-row class="d-flex justify-center mt-4" v-else>
            <v-list subheader two-line>
                <v-list-item
                    v-for="(mesaData, index) in mesas"
                    :key="mesaData.mesa + mesaData.ocg"
                >
                    <v-list-item-avatar>
                        <v-avatar color="light-blue darken-4" size="36">
                            <span class="white--text">{{ index + 1 }}</span>
                        </v-avatar>
                    </v-list-item-avatar>

                    <v-list-item-content class="text-left">
                        <v-list-item-title
                            v-text="mesaData.ocg"
                        ></v-list-item-title>
                        <v-list-item-title
                            v-text="mesaData.mesa"
                        ></v-list-item-title>

                        <v-list-item-subtitle
                            v-text="mesaData.desc_ures"
                        ></v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    :disabled="isLoading"
                                    icon
                                    @click="openAlta(mesaData)"
                                    color="#01579b"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <i class="fa fa-box-open"></i>
                                </v-btn>
                            </template>
                            <span>Descargar acta de apertura</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    :disabled="isLoading || !electionFinished"
                                    icon
                                    @click="openCierre(mesaData)"
                                    :color="electionFinished ? '#01579b' : ''"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <i class="fa fa-box"></i>
                                </v-btn>
                            </template>
                            <span>Descargar acta de cierre</span>
                        </v-tooltip>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </v-row>
        <v-dialog v-model="dialogAlta" persistent max-width="360px">
            <v-card>
                <v-card-title class="headline">Acta de apertura</v-card-title>
                <v-card-text>
                    <v-row class="d-flex ma-4 justify-center">
                        <v-btn depressed color="primary" @click="printAlta()">
                            Descargar formato
                        </v-btn>
                    </v-row>
                    <div v-if="selectedMesa">
                        <v-row
                            v-if="
                                selectedMesa.apertura_file_url &&
                                    !editingDocument
                            "
                            class="d-flex ma-4 justify-center"
                        >
                            <v-btn
                                depressed
                                color="primary"
                                @click="
                                    openAltaFirmada(
                                        selectedMesa.apertura_file_url
                                    )
                                "
                            >
                                Descargar acta firmada
                            </v-btn>
                        </v-row>
                        <v-row
                            v-if="selectedMesa.apertura_file_url"
                            class="d-flex ma-4 justify-center"
                        >
                            <v-btn
                                v-if="editingDocument"
                                depressed
                                color="primary"
                                @click="editingDocument = false"
                            >
                                Cancelar edición
                            </v-btn>
                            <v-btn
                                v-else
                                depressed
                                color="primary"
                                @click="editingDocument = true"
                            >
                                Reemplazar acta firmada
                            </v-btn>
                        </v-row>
                        <v-row
                            v-if="
                                !selectedMesa.apertura_file_url ||
                                    editingDocument
                            "
                            class="d-flex ma-4 justify-center"
                        >
                            <v-file-input
                                v-model="altaActaDocument"
                                show-size
                                label="Acta firmada"
                            ></v-file-input>
                        </v-row>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        :loading="isLoading"
                        :disabled="isLoading"
                        color="green darken-1"
                        text
                        @click="closeAlta()"
                    >
                        Cerrar
                    </v-btn>
                    <v-btn
                        :loading="isLoading"
                        :disabled="isLoading"
                        color="green darken-1"
                        text
                        @click="uploadAlta()"
                        v-if="
                            (selectedMesa && !selectedMesa.apertura_file_url) ||
                                editingDocument
                        "
                    >
                        Subir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogCierre" persistent max-width="360px">
            <v-card>
                <v-card-title class="headline">Acta de cierre</v-card-title>
                <v-card-text>
                    <v-row class="d-flex ma-4 justify-center">
                        <v-btn depressed color="primary" @click="printCierre()">
                            Descargar formato
                        </v-btn>
                    </v-row>
                    <div v-if="selectedMesa">
                        <v-row
                            v-if="
                                selectedMesa.cierre_file_url && !editingDocument
                            "
                            class="d-flex ma-4 justify-center"
                        >
                            <v-btn
                                depressed
                                color="primary"
                                @click="
                                    openAltaFirmada(
                                        selectedMesa.cierre_file_url
                                    )
                                "
                            >
                                Descargar acta firmada
                            </v-btn>
                        </v-row>
                        <v-row
                            v-if="selectedMesa.cierre_file_url"
                            class="d-flex ma-4 justify-center"
                        >
                            <v-btn
                                v-if="editingDocument"
                                depressed
                                color="primary"
                                @click="editingDocument = false"
                            >
                                Cancelar edición
                            </v-btn>

                            <v-btn
                                v-else
                                depressed
                                color="primary"
                                @click="editingDocument = true"
                            >
                                Reemplazar acta firmada
                            </v-btn>
                        </v-row>
                        <v-row
                            v-if="
                                !selectedMesa.cierre_file_url || editingDocument
                            "
                            class="d-flex ma-4 justify-center"
                        >
                            <v-file-input
                                v-model="cierreActaDocument"
                                show-size
                                label="Acta firmada"
                            ></v-file-input>
                        </v-row>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="isLoading"
                        color="green darken-1"
                        text
                        @click="closeCierre()"
                    >
                        Cerrar
                    </v-btn>
                    <v-btn
                        :disabled="isLoading"
                        color="green darken-1"
                        text
                        @click="uploadCierre()"
                        v-if="
                            selectedMesa &&
                                (!selectedMesa.cierre_file_url ||
                                    editingDocument)
                        "
                    >
                        Subir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogApi" persistent max-width="360px">
            <v-card>
                <v-card-title class="headline"></v-card-title>
                <v-card-text>
                    <v-row class="d-flex ma-4 justify-center">
                        <h5>El archivo ha sido Subido Correctamente</h5>
                        <v-btn
                            depressed
                            color="primary"
                            @click="openAltaFirmada(fileActive)"
                        >
                            <i class="fa fa-file-pdf"></i> Descagar Archivo
                        </v-btn>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="isLoading"
                        color="green darken-1"
                        text
                        @click="closeDialog()"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import {
    ADMIN_TYPE,
    FUNCIONARIO_TYPE,
    SECRETARIA_TYPE,
    SUBCOMISION_TYPE,
} from '@/helpers/roleTypes';

export default {
    computed: {
        ...mapGetters({
            mesas: 'funcionarios/mesas',
            user: 'user',
            elecciones: 'elecciones/elecciones',
        }),
    },
    components: {},
    data() {
        return {
            ADMIN_TYPE,
            FUNCIONARIO_TYPE,
            SECRETARIA_TYPE,
            SUBCOMISION_TYPE,
            headersAdmins: [
                {
                    text: 'Ures',
                    value: 'ures',
                },
                {
                    text: 'Desc Ures',
                    value: 'desc_ures',
                },
                {
                    text: 'OCG',
                    value: 'ocg',
                },
                {
                    text: 'Desc Ocg',
                    value: 'desc_ocg',
                },
                {
                    text: 'Estatus mesa',
                    value: 'status',
                    sortable: false,
                },
                {
                    text: 'Mesa',
                    value: 'mesa',
                },
                {
                    text: 'Nº Mesa',
                    value: 'no_mesa',
                },
                {
                    text: 'Actas',
                    value: 'actions',
                    sortable: false,
                },
            ],
            searchAdmins: '',
            electionFinished: false,
            selectedMesa: null,
            electionIdSelected: '',
            editingDocument: false,
            altaActaDocument: null,
            cierreActaDocument: null,
            dialogAlta: false,
            dialogCierre: false,
            isLoading: false,
            selectedIndex: null,
            dialogApi: false,
            fileActive: '',
        };
    },
    methods: {
        getStatusMesa(item) {
            const { voting_station } = item;
            if (!voting_station || Object.keys(voting_station).length === 0) {
                return 'No info';
            }

            const { is_open, opened_at } = voting_station;

            if (is_open && opened_at) {
                return 'Mesa Aperturada';
            } else if (!is_open && opened_at) {
                return 'Mesa Cerrada';
            } else if (!is_open && !opened_at) {
                return 'Mesa sin Aperturar';
            } else {
                return 'No info';
            }
        },
        openAlta(mesa) {
            this.selectedMesa = mesa;
            if (this.permissionAdmin()) {
                this.altaActaDocument = null;
                this.dialogAlta = true;
            } else {
                this.printAlta();
            }
        },
        openCierre(mesa) {
            if (!this.electionFinished) return;
            this.selectedMesa = mesa;
            if (this.permissionAdmin()) {
                this.cierreActaDocument = null;
                this.dialogCierre = true;
            } else {
                this.printCierre();
            }
        },
        openAltaFirmada(url) {
            window.open(url, '_blank');
        },
        openCierreFirmada(url) {
            window.open(url, '_blank');
        },
        closeAlta() {
            this.selectedMesa = null;
            this.dialogAlta = false;
        },
        closeCierre() {
            this.selectedMesa = null;
            this.dialogCierre = false;
        },
        closeDialog() {
            this.dialogApi = false;
        },
        openDialog() {
            this.dialogApi = true;
        },
        printAlta() {
            this.isLoading = true;
            const dataPrintAlta = {
                mesaInfo: this.selectedMesa,
                election_id: this.electionIdSelected,
            };
            this.$store
                .dispatch('funcionarios/printAlta', dataPrintAlta)
                .then(response => {
                    console.log(response);
                    let blob = new Blob([response], {
                        type: 'application/pdf',
                    });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `Apertura-${this.selectedMesa.mesa}-${this.selectedMesa.ocg}.pdf`;
                    link.click();

                    this.isLoading = false;
                })
                .catch(error => {
                    console.error(error);

                    this.isLoading = false;
                    this.$store.dispatch('errorMessage', error);
                });
        },
        printCierre() {
            this.isLoading = true;
            const dataPrintCierre = {
                mesaInfo: this.selectedMesa,
                election_id: this.electionIdSelected,
            };
            this.$store
                .dispatch('funcionarios/printCierre', dataPrintCierre)
                .then(response => {
                    let blob = new Blob([response], {
                        type: 'application/pdf',
                    });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `Cierre-${this.selectedMesa.mesa}-${this.selectedMesa.ocg}.pdf`;
                    link.click();
                })
                .catch(error => {
                    console.error(error);
                    this.$store.dispatch('errorMessage', error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        uploadAlta() {
            const formData = new FormData();
            formData.append('file', this.altaActaDocument);
            formData.append('election_id', this.electionIdSelected);
            formData.append('mesa', this.selectedMesa.mesa);
            formData.append('ocg', this.selectedMesa.ocg);

            this.$store
                .dispatch('funcionarios/uploadAlta', {
                    formData,
                })
                .then(response => {
                    let file = response.file;
                    let result = response.response;
                    this.fileActive = response.file;
                    if (result) {
                        this.loadTables();
                        this.closeAlta();

                        this.openDialog();
                    } else {
                        this.fileActive = '';
                    }
                    this.selectedMesa.apertura_file_url = file;
                    this.editingDocument = false;
                });
        },
        uploadCierre() {
            const formData = new FormData();
            formData.append('file', this.cierreActaDocument);
            formData.append('election_id', this.electionIdSelected);
            formData.append('mesa', this.selectedMesa.mesa);
            formData.append('ocg', this.selectedMesa.ocg);

            this.$store
                .dispatch('funcionarios/uploadCierre', {
                    formData,
                })
                .then(response => {
                    let file = response.file;
                    let result = response.response;
                    this.fileActive = response.file;
                    if (result) {
                        this.loadTables();
                        this.closeCierre();

                        this.openDialog();
                    } else {
                        this.fileActive = '';
                    }
                    this.selectedMesa.cierre_file_url = file;
                    this.editingDocument = false;
                });
        },
        onChangeElection() {
            if (!this.electionIdSelected) return;
            this.loadTables();
        },
        loadTables() {
            this.isLoading = true;
            this.$store
                .dispatch('funcionarios/getMesas', {
                    election_id: this.electionIdSelected,
                })
                .then(electionFinished => {
                    this.electionFinished = electionFinished;
                })
                .catch(error => {
                    console.error(error);
                    this.$store.dispatch('errorMessage', error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        permissionAdmin() {
            return (
                this.user.mode === ADMIN_TYPE ||
                this.user.mode === SECRETARIA_TYPE ||
                this.user.mode === SUBCOMISION_TYPE
            );
        },
        textItemElection: item =>
            `${item.id} - ${item.description} | ${item.type.toUpperCase()}`,
    },
    created() {
        this.$store.commit('funcionarios/SET_MESAS', []);
        if (this.user.mode === FUNCIONARIO_TYPE) {
            this.loadTables();
        } else {
            this.$store.dispatch('elecciones/getElecciones');
            this.isLoading = false;
        }
    },
};
</script>
<style lang="scss">
.table-admins {
    margin-bottom: 100px;

    .datatable-admins {
        width: 100%;
    }
}
</style>
